import React from "react";
import { Link } from "react-router-dom";
import registerBookImg from "../../assets/register-book.png";
import joinMeetingImg  from "../../assets/join-meeting.png";
import oneToOneImg     from "../../assets/one-to-one.png";
import practiceImg     from "../../assets/practice.png";
import "./HowDoesItWork.css";

const steps = [
  {
    title: "Register",
    subtitle: "Sign up for the first time",
    icon: "📱",
    image: registerBookImg,
    details: ["Sign up for the first time", "Get 5 free sessions automatically"],
  },
  {
    title: "Book Your Session",
    subtitle: "Choose your preferred time",
    icon: "🗓️",
    image: joinMeetingImg,
    details: ["Go to speakboldwithkk.com", "Or open the Speak Bold Club App", "View the 'Upcoming Live Sessions' tab", "Book your first slot"],
  },
  {
    title: "Join the Meeting",
    subtitle: "Access your session",
    icon: "⏳",
    image: oneToOneImg,
    details: ["Open your timetable page", "Click the 'Join' button", "Access meetings 5 minutes early", "Install the Zoom app beforehand"],
  },
  {
    title: "Practice with a Partner",
    subtitle: "Improve your speaking skills",
    icon: "👥",
    image: practiceImg,
    details: ["Match with a practice partner", "Pairings depend on your session type"],
  },
];

const HowDoesItWork = () => (
  <section id="how-it-works" className="hiw-section">
    <div className="hiw-header">
      <h2 className="hiw-title">How Does It Work? 📱</h2>
      <p className="hiw-subtitle">Follow these simple steps to start your English speaking journey</p>
    </div>

    <div className="hiw-grid">
      {steps.map((step, i) => (
        <div key={i} className="hiw-card">
          <div className="hiw-card-img-wrap">
            <img src={step.image} alt={step.title} loading="lazy" className="hiw-card-img" />
          </div>
          <div className="hiw-card-body">
            <span className="hiw-step-icon">{step.icon}</span>
            <h3 className="hiw-step-title">Step {i + 1}: {step.title}</h3>
            <p className="hiw-step-subtitle">{step.subtitle}</p>
            <ul className="hiw-step-list">
              {step.details.map((d, j) => <li key={j}>{d}</li>)}
            </ul>
          </div>
        </div>
      ))}
    </div>

    <div className="hiw-cta">
      <Link to="/register" className="hiw-cta-btn">Get Started — It's Free! 🚀</Link>
    </div>
  </section>
);

export default HowDoesItWork;
